<template>
<v-footer>
    <v-container>
        <v-row justify="center" align="center" no-gutters>
            <v-col class="text-center mx-3 my-1" v-for="(item, i) in items" :key="i" style="cursor: pointer" cols="auto" @click="item.callback">
                {{ item.text }}
            </v-col>
        </v-row>
    </v-container>
</v-footer>
</template>

<script>
export default {
    name: 'AppFooter',
    data: (vm) => ({
        items: [{
                text: 'About Us',
                callback: () => {
                    vm.$router.push('/about-us')
                }
            },
            {
                text: '이용약관 & 개인정보처리방침',
                callback: () => {
                    vm.$router.push('/terms-policy')
                }
            },
            {
                text: '공식 커뮤니티',
                callback: () => {
                    window.open('https://cafe.naver.com/investhelper', '_blank')
                }
            },
            {
                text: '개발자 후원',
                callback: () => {
                    vm.$router.push('/sponsor')
                }
            },
            {
                text: 'Contact Us',
                callback: () => {
                    vm.$router.push('/contact-us')
                }
            },
        ],
    }),
    methods: {
    }
}
</script>